<template>
  <el-row :gutter="20" class="sec_box d2-mt-10" v-loading="loading">
    <template v-if="readData.length != 0">
      <el-col
        :span="24"
        v-for="(item, index) in readData"
        :key="index"
        class="list_item_box"
        :title="item.Title"
      >
        <!-- <i class="el-icon-document-copy"></i> -->
        <img class="pdf_icon" src="@/assets/img/pdf.png" />
        <div class="list_item_info" @click="listDetialHandle(item)">
          <p class="list_item_title">{{ item.FileNames || "-" }}</p>
          <span class="list_item_time">{{ item.CreateTime || "-" }}</span>
        </div>
        <div class="align-center">
          <div class="list_item_copy" @click.stop="handleCopy(item.FilePaths)">
            <i class="el-icon-document-copy"></i>
            复制链接
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty class="auto"></el-empty>
    </template>
    <!--  -->
    <el-dialog
      title="查看pdf查看"
      :visible.sync="dialogVisible"
      :fullscreen="true"
    >
      <div class="content">
        <iframe
          class="pdf-view"
          :style="{width: '100%',height: iframeHeight+'px'}"
          :src="pdfurl"
          frameborder="0"
        >
        </iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import * as indexService from "@/api/sys/index";
export default {
  name: "listPicture",
  data() {
    return {
      listDetialData: {},
      listDetialVisible: false,
      dialogVisible: false,
      pdfurl: "",
      iframeHeight: "0",
    };
  },
  props: {
    code: {
      type: String,
      required: false,
      default: "",
    },
    ListData: {
      type: Array,
      required: false,
      default: () => [],
    },
    readData: {
      type: Array,
      required: false,
      default: () => [],
    },
    total: {
      type: Number,
      required: false,
      default: 0,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    listDetialHandle(item) {
      this.dialogVisible = true;
      this.pdfurl = item.FilePaths;
      let clientHeight = document.documentElement.clientHeight;
      this.iframeHeight = clientHeight - 127;
    },
    handleCopy(val) {
      var copyInput = document.createElement("input");
      //val是要复制的内容
      copyInput.setAttribute("value", val);
      document.body.appendChild(copyInput);
      copyInput.select();
      try {
        var copyed = document.execCommand("copy");
        if (copyed) {
          document.body.removeChild(copyInput);
          this.$message.success("复制成功");
        }
      } catch (e) {
        this.$message.error("复制失败，请检查浏览器兼容");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/style.css";
@import "~@/assets/style/richText.scss";
/deep/ .el-dialog__body {
  padding: 0 20px 0 20px;
}
</style>